import { Button } from "@mui/material";
import { ColorsConstants } from "../cssUtils/constants";
import typography from "../cssUtils/typography";

const ButtonOne = ({
  onClick,
  title,
  children,
  startIcon = null,
  endIcon = null,
  disabled = false,
  variant = "contained",
  sx,
  ...props
}) => {
  const isOutlined = variant === "outlined";

  return (
    <Button
      variant={variant}
      size="medium"
      disableElevation
      onClick={onClick}
      startIcon={startIcon}
      endIcon={endIcon}
      disabled={disabled}
      sx={[
        // Base typography styles
        typography.bodyLarge,
         
        // Conditional styles based on variant
        isOutlined ? {
          backgroundColor: "transparent",
          color: ColorsConstants.primaryBlue100,
          border: `1px solid ${ColorsConstants.primaryBlue100}`,
          "&:hover": {
            backgroundColor: "#F3F4F6",
            border: `1px solid ${ColorsConstants.primaryBlue100}`,
          },
          "&.Mui-disabled": {
            border: `1px solid ${ColorsConstants.primaryBlue100}`,
            color: ColorsConstants.primaryBlue100,
              opacity:0.5,
          },
        } : {
          backgroundColor: ColorsConstants.primaryBlue100,
          color: "white",
          "&:hover": {
            backgroundColor: ColorsConstants.primaryBlue100,
          },
          "&.Mui-disabled": {
            backgroundColor: ColorsConstants.primaryBlue100,
            opacity:0.5,
            color: "white",
          },
        },
        
        // Common styles
        {
          boxShadow: "none",
          "&:active": { boxShadow: "none" },
          "&:focus": { boxShadow: "none" },
          borderRadius: "8px",
          height: 40,
          textTransform: "capitalize",
        },
        
        // Custom styles
        sx
      ]}
      {...props}
    >
      {children ?? title}
    </Button>
  );
};

export default ButtonOne;